import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from "react";
import style from "./Lists.module.scss";
export type GenericListContextMenuOptions = {
  label: string;
  icon?: ReactNode;
}[];
export type GenericListContextMenuSelect<T> = (option: string, element: T) => void;
type Props<T> = {
  options: GenericListContextMenuOptions;
  element: T;
  onSelect: GenericListContextMenuSelect<T>;
};
export const GenericListContextMenu = t0 => {
  const $ = _c(9);
  const {
    options,
    element,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== element || $[1] !== onSelect || $[2] !== options) {
    let t2;
    if ($[4] !== element || $[5] !== onSelect) {
      t2 = (option, index) => <div className={style.contextDropdownItem} key={index} onClick={() => onSelect(option.label, element)}>{option.icon}<span>{option.label}</span></div>;
      $[4] = element;
      $[5] = onSelect;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = options.map(t2);
    $[0] = element;
    $[1] = onSelect;
    $[2] = options;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className={style.contextDropdownContainer}>{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};